import {
    defineStore,
} from 'pinia';
import {
    computed,
    reactive, toRefs,
} from 'vue';

export const useBlacklistStore = defineStore('profile-blacklist', () => {
    const state = reactive({
        blacklisted: [],
    });

    function updateFromQuery(data) {
        state.blacklisted = data.companies;
    }

    const model = computed(() => ({
        companies: state.blacklisted,
    }));

    return {
        ...toRefs(state),
        updateFromQuery,
        model,
    };
});

export function blacklistAutocompleteAdapter(company) {
    return company;
}
